import { render, staticRenderFns } from "./GiftCertificateSummary.vue?vue&type=template&id=166230ed"
import script from "./GiftCertificateSummary.vue?vue&type=script&lang=ts"
export * from "./GiftCertificateSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports